import { Link } from "react-router-dom";
import { Logo } from "../Logo";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="stack" style={{ gap: 12, maxWidth: 280 }}>
          <Logo />
          <small>
            Slack → Discord migration, watched live. Your data, preserved.
          </small>
        </div>
        <div className="footer-cols">
          <div className="footer-col">
            <h4>Product</h4>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/security">Security</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/how-it-works">Live status</Link>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
